<template>
    <div class="main-page-header">
        <div class="main-page-top-header">
            <div class="container">
                <div class="main-page-top-header-menu">
                    <span class="astext" @click="goNotice()">공지사항</span>
                    <template v-if="username === 'edumaster'">
                        <el-divider direction="vertical"></el-divider>
                        <span class="astext" @click="goMakerList()">문제생성</span>
                    </template>
                    <el-divider direction="vertical"></el-divider>
                    <span class="astext" @click="goLogin()">{{this.token ? '로그아웃' :'로그인'}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="astext" @click="goRegister" v-if="this.token === '' || this.token === null">회원가입</span>
                    <span class="astext" @click="goMyPage" v-if="this.token !== '' && this.token !== null">나의정보</span>
                </div>
            </div>
        </div>
        <div class="main-page-bottom-header">
            <div class="wrapper">
                <div class="main-page-logo img-div">
                    <router-link to="/"><img src="@/assets/메인로고.jpg"></router-link>
                </div>
                <div class="main-page-bottom-header-menu">
                    <div class="menu-grade">
                        <span class="astext" @click="clickGrade('초1')" :style="(selectedGrade === '초1')?'color:forestgreen;font-weight:bold':''">초1</span>
                        <template v-for="x in ['초2', '초3', '초4', '초5', '초6']">
                            <el-divider direction="vertical" :key="x"></el-divider>
                            <span :key="x+'_'" class="astext" @click="clickGrade(x)" :style="(selectedGrade === x)?'color:forestgreen;font-weight:bold':''">{{x}}</span>
                        </template>
                    </div>
                    <div class="menu-chapter">
                        <div class="problem">
                            <el-select v-model="problemValue"
                                       placeholder="소단원"
                                       @change="changeProblem"
                                       size="small">
                                <el-option
                                        v-for="item in problemOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="chapter">
                            <el-select
                                    v-model="chapterValue"
                                    placeholder="대단원"
                                    @change="changeChapter"
                                    size="small">
                                <el-option-group
                                        v-for="group in chapterOptions"
                                        :key="group.label"
                                        :label="group.label">
                                    <el-option
                                            v-for="item in group.options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Variables from '../../controller/variables'

    export default {
        name: "header.vue",
        data() {
          return {
              chapterValue: '',
              chapterOptions: [],
              problemValue: '',
              problemOptions: [],
              selectedGrade: ''
          }
        },
        methods: {
            goRegister() {
                window.open("http://e8760.co.kr/student/join/joinOne");
            },
            goMyPage() {
                window.open("http://e8760.co.kr/myPage/myInfo");
            },
            goMakerList() {
                this.$router.push(`/maker/list`)
            },
            clickGrade(gradeString) {
                let grade;
                if (gradeString.indexOf('초') !== -1) {
                    grade = gradeString.replace('초', '');
                } else {
                    grade = Number(gradeString.replace('중', '')) + 6;
                }
                this.selectedGrade = gradeString

                this.$store.commit('setGrade', {
                    grade: grade
                });

                this.$http.get(`/api/chapter/${this.inform.grade}`)
                    .then((result) => {
                        this.chapterOptions = [
                            {
                                label: "1학기",
                                options: []
                            },
                            {
                                label: "2학기",
                                options: []
                            }
                        ];
                        for (const data of result.data) {
                            console.log(data)
                            const temp = {
                                value: `${data.id}`,
                                label: `${data.name}`
                            };
                            if (data.semester.indexOf("1") !== -1) this.chapterOptions[0]['options'].push(temp);
                            else this.chapterOptions[1]['options'].push(temp);
                        }
                        this.chapterValue = this.chapterOptions[0]['options'][0].value;
                        this.problemValue = '';
                        this.problemOptions = [];

                        this.changeChapter();
                    })
            },
            changeChapter() {
                const semester = this.chapterValue.split(' ')[0],
                    chapter = this.chapterValue.split(' ')[1];
                this.$store.commit('setSemester',
                    {
                        semester: semester
                    });
                this.$store.commit('setChapter',
                    {
                        chapter: chapter
                    });
                this.$http.get(`/api/questions/info?chapter_id=` + this.chapterValue)
                    .then((result) => {
                        this.problemOptions = [];
                        this.problemValue = '';
                        for (const data of result.data) {
                            const temp = {
                                value: data.id,
                                label: data.questionName
                            };
                            this.problemOptions.push(temp);
                        }
                    })
            },
            async changeProblem(v) {
                this.$store.commit('setMode', {mode: 0});
                let problemInfo = (await this.$http.get(`/api/questions/get?id=${v}`)).data
                let vars = new Variables()
                let data = vars.convert(problemInfo)
                let problemId = (await this.$http.post(`/api/make`, data)).data.id;
                this.$router.push(`/testviewer/${problemId}`).catch(() => {})
            },
            goLogin() {
                if (this.token) {
                    this.$store.commit('delToken');
                    this.$http.defaults.headers.common['x-access-token'] = undefined;
                    this.$router.push('/').catch(()=> {});
                } else {
                    this.$router.push('/login').catch(()=> {});
                }
            },
            goNotice() {
                this.$router.push('/notice').catch(()=> {});
            }
        },
        mounted() {
            this.clickGrade("초1");
        },
        computed: mapGetters({
            inform: "getState",
            token: "getToken",
            username: "getUsername"
        })
    }
</script>

<style scoped>
    .main-page-header {
        height: 180px;
        margin: 0 auto;
        width: 874px;
        text-align: center;
    }
    .main-page-top-header {
        font-size: 10pt;
        font-family: "나눔스퀘어 Regular";
        margin: 0px auto;
        padding-top: 20px;
        height: 20px;
        width: 100%;
        text-align: center;
    }
    .container {
        width: 100%;
    }
    .main-page-top-header-menu{
        text-align: right;
        min-width: 0;
    }
    .main-page-bottom-header {
        text-align: center;
        max-width: 1400px;
        margin: 0 auto;
    }
    .main-page-bottom-header-menu {
        font-size: 15pt;
        font-family: "나눔스퀘어 Regular";
        color: #000000;
        margin-top: 40px;
    }
    .wrapper {
        margin: 0 auto;
    }
    .main-page-logo {
        float: left;
    }
    .main-page-bottom-header-menu {
        display: inline-block;
        float: right;
    }
    .main-page-bottom-header-menu > div {
    }
    .menu-grade {
        text-align: right;
    }
    .menu-grade > span {
        margin-left: 10px;
        margin-right: 10px;
    }
    .menu-chapter > div{
        float: right;
        margin-top: 15px;
        margin-left: 20px;
    }
    .astext {
        background:none;
        border:none;
        margin:0;
        padding:0;
        cursor: pointer;
    }
</style>